// extracted by css-extract-rspack-plugin
export default {"connectedTable":"JWSYR","label":"Vu7df"};